import { ThemeContext } from "contexts";
import React, { useContext, useState } from "react";
import PoweredByClinicOS from "./PoweredByClinicOS";
import Loading from "./Loading";

type PrimaryButtonProps = {
  onClick: () => void;
  text: string;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  displayPoweredBy?: boolean;
  type?: "button" | "submit" | "reset"; // Adding the type property
  useThemeColor?: boolean;
};

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  onClick,
  text,
  disabled = false,
  loading = false,
  fullWidth = false,
  displayPoweredBy = true,
  type = "button", // Default to "button"
  useThemeColor = true,
}) => {
  const theme = useContext(ThemeContext);
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div style={styles.container}>
      <button
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
        disabled={disabled || loading}
        style={{
          ...styles.button,
          width: fullWidth ? "100%" : "auto",
          background:
            disabled || loading
              ? "#C4C6CD"
              : useThemeColor
                ? theme?.themeColor ?? "#1C646E"
                : "#00B4F4",
          filter: isHovered ? "brightness(80%)" : "brightness(100%)",
          cursor: disabled || loading ? "not-allowed" : "pointer",
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        type={type} // Setting the button type
      >
        {loading ? <Loading small /> : text}
      </button>
      {displayPoweredBy && <PoweredByClinicOS />}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    gap: 10,
  },
  button: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: 600,
    transition: "filter 0.3s ease",
    border: "0",
    padding: "10px 20px",
    borderRadius: "80px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    height: "39px",
  },
} as const;

export default PrimaryButton;
